import React from 'react';
import './Auth.css';

function InputField({ 
  label, 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  error, 
  required = false,
  name 
}) {
  return (
    <div className="input-group">
      <label className="input-label">
        {label}{required && <span className="required">*</span>}
      </label>
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`input-field ${error ? 'input-error' : ''}`}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export default InputField;
